export default "__VITE_ASSET__DqmBhswa__"